import { Bullet } from "../Bullet/Bullet";
import {
  movePlayerDown,
  movePlayerUp,
  movePlayerLeft,
  movePlayerRight,
  shoot,
} from "../../redux/actions/actions";

class Player {
  constructor(game, keys, dispatch, entrance) {
    this.game = game;

    this.width = 100;
    this.height = 100;

    this.dispatch = dispatch;

    this.keys = keys;

    this.x = game.width / 2;
    this.y = this.game.height;

    this.velocity = 0.2;

    this.bullets = [];

    this.shootCoolDown = 500;

    this.lastShotTime = 0;

    this.playerImage = new Image();
    this.playerImage.src = "https://dawn-unit-97b0.sdrowvieli1.workers.dev/infiltration/images/spaceship.webp";

    this.entrance = entrance;
  }

  setEntrance(entrance) {
    this.entrance = entrance;
  }

  update(deltaTime) {
    if (this.x < 0) this.x = 0;
    if (this.x + this.width > this.game.width)
      this.x = this.game.width - this.width;
    if (this.y < 0) this.y = 0;
    if (this.y + this.height > this.game.height)
      this.y = this.game.height - this.height;

    if (this.keys["ArrowLeft"] || this.keys["KeyA"] || this.keys["a"])
      this.dispatch(movePlayerLeft(this, deltaTime));
    if (this.keys["ArrowRight"] || this.keys["KeyD"] || this.keys["d"])
      this.dispatch(movePlayerRight(this, deltaTime));
    if (this.keys["ArrowUp"] || this.keys["KeyW"] || this.keys["w"])
      this.dispatch(movePlayerUp(this, deltaTime));
    if (this.keys["ArrowDown"] || this.keys["KeyS"] || this.keys["s"])
      this.dispatch(movePlayerDown(this, deltaTime));
    if (this.keys["Space"]) this.dispatch(shoot(this));

    this.bullets.forEach((bullet) => bullet.update(deltaTime));
    
    this.bullets = this.bullets.filter((bullet) => !bullet.markedForDeletion);
  }

  draw(ctx) {
    if (ctx) ctx.drawImage(this.playerImage, this.x, this.y, this.width, this.height);

    this.bullets.forEach((bullet) => {
      bullet.draw(ctx);
    });
  }

  shoot() {
    const currentTime = new Date().getTime();
    
    if (currentTime - this.lastShotTime > this.shootCoolDown) {
      this.bullets.push(
        new Bullet(this.x + this.width / 2, this.y + this.height / 2, this.game)
      );
      this.lastShotTime = currentTime;
    }
  }
}

export { Player };
